import * as React from 'react';
import { Control, Errors, Form } from 'react-redux-form';
import { Redirect } from 'react-router';

import { LoginViewModel } from '@models/Auth';
import { Role } from '@models/Roles';
import { getDefaultErrorMessages, hasValue, isValidEmail } from '@common/validators';
import * as classes from './login.scss';
import { RouteDefinitions } from '@common/route-definitions';
import { config } from '@common/config';
// Defining the properties the component expects
// Consider this the "setup" of the component
// All properties should be readonly
export interface LoginComponentProperties {
  readonly message?: string;
  readonly isLoggedIn: boolean;
  readonly isLoggingIn: boolean;
  readonly doRequest: (model: LoginViewModel) => void;
}

export class LoginComponent extends React.Component<LoginComponentProperties> {
  state = {
    userLoggedInButHasNoRoles: false
  };

  render() {
    const { userLoggedInButHasNoRoles } = this.state;

    if (this.props.isLoggedIn && !this.props.isLoggingIn && Role.GetUserRoles()) {
      if (Role.GetUserRoles()!.length > 0) {
        return <Redirect to={RouteDefinitions.root} />;
      } else if (!this.state.userLoggedInButHasNoRoles) {
        this.setState({ userLoggedInButHasNoRoles: true });
      }
    }

    return (
      <section className={classes.login}>
        <div className="row center-xs middle-xs">
          <Form model="loginForm" onSubmit={this.props.doRequest} hideNativeErrors={true}>
            <h2>Sign In</h2>
            <h3>Enter your username and password to sign in.</h3>
            <div className="row center-xs">
              <div className="form-control col-md-8 mb-10">
                <label htmlFor="model.username">Email Address</label>
                <Control.text model=".username" validators={{ required: hasValue, invalidUserName: isValidEmail }} />
                <Errors
                  className="error"
                  model=".username"
                  show={{ touched: true, focus: false }}
                  messages={getDefaultErrorMessages({ invalidUserName: 'Invalid Username' })}
                />
              </div>
              <div className="form-control col-md-8 mb-10">
                <label htmlFor="model.password">Password</label>
                <Control.text type="password" model=".password" validators={{ required: hasValue }} />
                <Errors
                  className="error"
                  model=".password"
                  show={{ touched: true, focus: false }}
                  messages={getDefaultErrorMessages()}
                />
              </div>
            </div>
            <div className="row center-xs middle-xs">
              {/* {(this.props.message) && <div className="form-group"><div className=" col-xs-12">{this.props.message}</div></div>} */}
              {/* <div className="col-xs-12 mb-10 pb-10">
                <div className="row middle-xs between-xs"> */}
              {/* <div className="col-xs-6 mb-10 pb-10">
                <CheckboxInline>
                  <Control.checkbox model=".rememberMe" />
                  <label htmlFor="model.rememberMe">Remember Me</label>
                </CheckboxInline>
              </div> */}
              {/* </div>
              </div> */}
              {/* <div className="col-xs-12 mb-10 pb-10">
                <Link to={RouteDefinitions.root}>I forgot my password</Link>
              </div> */}
              <div className="col-xs-12 mb-10 pb-10">
                <a href={'https://sts.fnf.com/adfs/ls/idpinitiatedsignon.aspx?LoginToRP=' + config.host}>
                  I am a Fidelity Employee
                </a>
              </div>
            </div>
            <div className="row middle-xs center-xs mt-10 pt-10">
              {/* <Link to="/">
                <button className="btn btn-secondary" type="button">Back to Homepage</button>
              </Link> */}
              <button className="btn btn-primary" type="submit">
                Sign In
              </button>
            </div>
            <div className="col-xs-offset-4 col-xs-4">
              <Errors
                className="error"
                model="model"
                show={true}
                messages={{ noMatch: 'Username and Password must be different.' }}
              />
            </div>
            {userLoggedInButHasNoRoles && (
              <div className="col-xs-12">
                <h4 className="active">
                  This user has no roles available in WISE. Please contact FNHW to create your role with WISE to
                  continue login.{' '}
                </h4>
              </div>
            )}
          </Form>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/auth/_components/login.component.tsx